export default "__VITE_ASSET__CXSDkn_u__"